import { dataHooks } from '@wix/data-hooks';

import { QUICK_ADD_HORIZONTAL_ALIGNMENT } from '../../../constants';

export const addToCartControlDataHooks = dataHooks<{
  root: {};
  addButton: {};
  stepper: {};
  label: {};
}>('add-to-cart-control');

export const ALIGNMENT_NAME: Record<
  QUICK_ADD_HORIZONTAL_ALIGNMENT,
  'left' | 'center' | 'right'
> = {
  [QUICK_ADD_HORIZONTAL_ALIGNMENT.LEFT]: 'left',
  [QUICK_ADD_HORIZONTAL_ALIGNMENT.CENTER]: 'center',
  [QUICK_ADD_HORIZONTAL_ALIGNMENT.RIGHT]: 'right',
};
